'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface ParagraphProps {
  children?: React.ReactNode;
  innerHtml?: string;
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
  size?: 'sm' | 'base' | 'lg' | 'xl' | '2xl';
  tag?: 'p' | 'div';
  color?: 'white' | 'muted-foreground' | 'muted' | 'black' | 'primary';
  onClick?: () => void;
}

export function Paragraph({
  children,
  innerHtml,
  className,
  ref,
  size = 'lg',
  color = 'black',
  tag = 'div',
  onClick,
}: ParagraphProps) {
  const Tag = tag;

  if (innerHtml) {
    return (
      <HtmlRendererRaw
        as={Tag}
        onClick={onClick}
        ref={ref}
        className={cn(
          'transition-all',
          'ea-paragraph__inner-html',
          `ea-paragraph__inner-${size}`,
          `ea-paragraph__inner-${color}`,
          onClick && 'cursor-pointer text-opacity-80',
          className,
        )}
        html={innerHtml}
      />
    );
  }

  return (
    <p
      onClick={onClick}
      className={cn(
        'ea-paragraph',
        'transition-all',
        size === 'sm' && 'text-xs sm:text-sm',
        size === 'base' && 'text-sm sm:text-base',
        size === 'lg' && 'text-sm lg:text-base',
        size === 'xl' && 'text-lg lg:text-xl',
        size === '2xl' && 'text-lg sm:text-xl lg:text-2xl',
        color === 'white' && 'text-white',
        color === 'muted-foreground' && 'text-muted-foreground',
        color === 'black' && 'text-black',
        color === 'muted' && 'text-muted',
        color === 'primary' && 'text-primary',
        onClick && 'cursor-pointer text-opacity-80',
        className,
      )}
    >
      {children}
    </p>
  );
}
